function canActivatePendingInternal({ pageItem, store }) {
  const uid = pageItem?.ID;
  const gates = ["Enabled", "InternalEnabled", "CustomerEnabled", "SignatoryEnabled", "MilitarySignatoryEnabled", "FlightTestCrewEnabled"];
  const pending = pageItem?.Provisioning?.Internal;
  return store?.state?.user?.Security?.General?.ApplicationAdmin === true
    && typeof uid === "string" && uid.length > 0 && uid === uid.trim() && uid.length <= 128 && !/[.#$\[\]/\u0000-\u001f\u007f]/.test(uid)
    && pageItem.SchemaVersion === 2 && pageItem.Basic?.ID === uid && pageItem.Basic?.key === uid
    && (pageItem.Basic.uid == null || pageItem.Basic.uid === uid)
    && typeof pageItem.Basic.name === "string" && pageItem.Basic.name.trim().length > 0
    && typeof pageItem.Basic.email === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pageItem.Basic.email)
    && pending?.Source === "legacy-home-new-user" && pending.Status === "pending"
    && gates.every(gate => pageItem.Access?.[gate] === false)
    && pageItem.Security != null && typeof pageItem.Security === "object" && !Array.isArray(pageItem.Security)
    && Object.values(pageItem.Security).every(flags => flags != null && typeof flags === "object" && !Array.isArray(flags) && Object.values(flags).every(value => value === false))
    && pageItem.Customer == null && Object.keys(pageItem.Profiles || {}).length === 0;
}

export { canActivatePendingInternal };
